import type { IComment } from 'garden-common';
import { api } from './index'
import { handleAxiosError } from './error-handler.util';

export const getPostComments = async (id: string, limit: number = 50, skip: number = 0) => {
  return await api(`/v2/comment/post/${id}`).then(res => {
    return res.data?.comments;
  });
};

export const getComment = async (id: string) => {
  return await api(`/v2/comment/${id}`).then(res => {
    return res.data?.comment;
  });
};

export const postComment = async (
	postId: string,
	commentText: string,
	donationAmount: number,
	taggedUser: string[]
) => {
	return api
		.post('/v2/comment/create', {
			postId: postId,
			commentText: commentText,
			commentPrice: donationAmount,
			taggedUser: taggedUser
		})
		.then((res) => {
			return res.data.Comment as IComment<string>;
		}).catch(handleAxiosError);;
};

export const editComment = async (
  id: string,
  commentText: string,
  tagDetect: boolean,
  taggedUser: string[]
) => {
  return api
    .patch(`/v2/comment/update/${id}`, {
      commentText: commentText,
      tagDetect: tagDetect,
      taggedUser: taggedUser
    })
    .then(res => {
      return res.data.Comment;
    });
};

export const postCommentReply = async (
	postId: string,
	parentComment: string,
	commentText: string,
	donationAmount: number,
	taggedUser: string[]
) => {
	return api
		.post('/v2/comment/createReply', {
			postId: postId,
			parentComment: parentComment,
			commentText: commentText,
			commentPrice: donationAmount,
			taggedUser: taggedUser
		})
		.then((res) => {
			return res.data.Comment;
		})
		.catch(handleAxiosError);;
};

export const getCommentsDetails = async (id: string) => {
  return api.get(`/v2/comment/${id}`).then(res => {
    return res.data.comment;
  });
};

export const deleteComment = async (commentId: string) => {
  return api
    .delete(`/v2/comment/delete/${commentId}`)
    .then(res => {
      return res.data.success;
    })
    .catch(handleAxiosError);
};

export const likeComment = async (commentId: string) => {
  return await api
    .post(`/v2/comment/like/${commentId}`)
    .then(res => {
      return res.data.success;
    })
    .catch(handleAxiosError);
};

export const unlikeComment = async (commentId: string) => {
  return await api
    .delete(`/v2/comment/unlike/${commentId}`)
    .then(res => {
      return res.data.success;
    })
    .catch(handleAxiosError);
};
